export const administration = {
  dashboard: {
    columns: {
      name: 'Name',
      loggedIn: 'Logged In',
      lastLoginAt: 'Last Login At',
      lastLogoutAt: 'Last Logout At',
      actions: 'Actions'
    },
    tooltips: {
      name: 'Name',
      loggedIn: 'Logged In',
      lastLoginAt: 'Last Login At',
      lastLogoutAt: 'Last Logout At',
      minutesToday: 'Time Logged In Today',
      minutesThisWeek: 'Time Logged In This Week',
      minutesThisMonth: 'Time Logged In This Month',
      minutesThisYear: 'Time Logged In This Year',
      activeMinutesToday: 'Time actively working today: the portal tab was visible and the user was active',
      activeMinutesThisMonth: 'Time actively working this month: the portal tab was visible and the user was active',
      activityToday: 'API Calls Today',
      activityThisWeek: 'API Calls This Week',
      activityThisMonth: 'API Calls This Month',
      activityThisYear: 'API Calls This Year'
    },
    headers: {
      todayMins: 'Today (mins)',
      totalMinsLoggedIn: 'Total Mins Logged In',
      thisWeekMins: 'This Week (mins)',
      thisMonthMins: 'This Month (mins)',
      ytdMins: 'YTD (mins)',
      totalActiveMins: 'Active Time (mins)',
      today: 'Today',
      totalApiPulls: 'Total API Pulls',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      ytd: 'YTD'
    }
  },
  users: {
    editUserDialogTitle: 'Edit User',
    deactivateUserDialogTitle: 'Deactivate User',
    columns: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      title: 'Title',
      npiNumber: 'NPI #',
      licenseNumber: 'License #',
      actions: 'Actions'
    },
    notApplicable: 'N/A',
    searchPlaceholder: 'User Lookup',
    details: {
      profileTab: 'Profile',
      email: 'Email',
      role: 'Role',
      npiNumber: 'NPI Number',
      sessions: 'Sessions',
      started: 'Started',
      ended: 'Ended',
      duration: 'Duration',
      accessDetails: 'Access Details',
      ip: 'IP',
      device: 'Device',
      noSessionSelected: 'No Session Selected',
      userNotFoundMessage: 'User not found',
      assignedPatients: 'Assigned Patients',
      patients: 'Patients',
      reports: 'Reports',
      recentSessions: 'Recent Sessions'
    },
    profileDialog: {
      dialogTitle: 'My Account',
      tabs: {
        profile: 'Profile',
        settings: 'Settings',
        billing: 'Billing',
        messaging: 'Messaging',
        security: 'Security'
      },
      banners: {
        observerSelf: 'You are an Observer. Your activities will not be included for billing.',
        observerOther: 'This user is an Observer. Activities of this user will not be included for billing.',
        rpmPrimary: 'This user will become the RPM Primary for the pharmacy. Any existing RPM Primary will be unset.'
      },
      sections: {
        roles: 'Roles',
        personal: 'Personal',
        credentials: 'Credentials',
        preferences: 'Preferences'
      },
      toggles: {
        pharmacyOwner: 'Pharmacy Owner',
        rpmPrimary: 'RPM Primary',
        observer: 'Observer'
      },
      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        title: 'Title',
        providerTitle: 'Provider Title',
        npiNumber: 'NPI Number',
        licenseNumber: 'License Number',
        mobilePhone: 'Mobile Phone',
        faxNumber: 'Fax Number',
        selectPlaceholder: 'Select an option...',
        businessName: 'Business Name',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        city: 'City',
        state: 'State',
        zipcode: 'Zipcode',
        phone: 'Phone',
        hourlyRate: 'Hourly Rate',
        supervisorEmail: 'Supervisor Email',
        bankName: 'Bank Name',
        bankRoutingNumber: 'Bank Routing Number',
        bankAccountNumber: 'Bank Account Number',
        messagingPhoneNumber: 'Messaging Phone Number',
        dialpadId: 'Dialpad ID',
        dialpadSelectPlaceholder: 'select an option',
        dialpadPhoneNumber: 'Dialpad Phone Number',
        unassignedOption: 'Unassigned'
      },
      uploadProfileImageModalTitle: 'Upload Profile Image',
      uploadPhotoButton: 'Upload Photo',
      activityLogReminderLabel: 'Activity Log Reminder',
      activityLogReminderHelper: "Prompt me to log activities when leaving a patient's page",
      security: {
        inactivitySettingsTitle: 'Inactivity Settings',
        inactivityTimeLabel: 'Inactivity Time (HH:mm)',
        inactivityTimeHelperText: 'Time for inactivity logout',
        reAuthenticationTitle: 'Re-Authentication',
        reAuthenticationCaption: 'Settings for re-authentication after inactivity',
        reAuthenticatePinLabel: 'Re-Authenticate with PIN',
        pinHelperText: '6 digit PIN',
        editPinButton: 'Edit PIN',
        cancelButton: 'Cancel',
        reAuthenticationTimeLabel: 'Re-Authentication Time (HH:mm)',
        rememberDeviceTitle: 'Remember This Device',
        rememberDeviceCaption: "Force this user to re-verify with OTP by clearing any devices they've marked as remembered",
        clearTrustedDevicesButton: 'Clear Trusted Devices'
      },
      saveButtonLabel: 'Save changes',
      cancelButtonLabel: 'Cancel',
      messages: {
        roleVerificationError: 'Could not verify the current role -- please reload and try again.',
        fieldRequired: 'This field is required',
        incompleteFormError: 'Please ensure all required fields in each tab are completed before submitting.',
        pinLengthError: 'PIN must be 6 digits',
        profileUpdateError: 'Unable to edit Profile',
        contactUpdateError: 'Unable to edit contact status',
        profileUpdateSuccess: 'Profile updated',
        npiRequiredError: 'NPI number is required for a provider admin',
        providerTitleRequiredError: 'Provider Title is required for a provider admin',
        trustedDevicesClearedSuccess: 'Trusted devices cleared',
        trustedDevicesClearError: 'Unable to clear trusted devices',
        avatarUploadError: 'Could not upload logo.',
        fileRetrievalError: 'Could not retrieve file.',
        profileFetchError: 'Unable to retrieve profile data'
      }
    }
  },
  organizations: {
    addOrganizationDialogTitle: 'Add Organization',
    editOrganizationDialogTitle: 'Edit Organization',
    sideMenuLabel: 'Organization',
    locationsNavLabel: 'Locations',
    loadingDetailsMessage: 'Getting Details...',
    columns: {
      name: 'Name',
      numLocations: '# of Locations',
      numPatients: '# of Patients',
      createdOn: 'Created On',
      actions: 'Actions'
    },
    info: {
      addedOn: 'Added on',
      profileTab: 'Profile',
      email: 'Email',
      numPatients: '# of Patients',
      phone: 'Phone',
      numLocations: '# of Locations',
      location: 'Location'
    },
    stores: {
      title: 'Locations',
      addLocation: 'Add Location',
      editLocation: 'Edit Location',
      columns: {
        name: 'Name',
        tag: 'Tag',
        isPrimary: 'Primary Client Store',
        actions: 'Actions'
      },
      form: {
        name: 'Name',
        nameTag: 'Name Tag',
        primaryClientOrg: 'Primary Client Org',
        addErrorMessage: 'Unable to add location',
        updateErrorMessage: 'Unable to update location'
      }
    },
    storeInfo: {
      profileTab: 'Profile',
      email: 'Email',
      numPatients: '# of Patients',
      phone: 'Phone',
      location: 'Location'
    },
    storeSideMenu: {
      sectionLabel: 'Store',
      patientsNavLabel: 'Patients',
      tasksNavLabel: 'Tasks'
    },
    patients: {
      title: 'Patients',
      columns: {
        firstName: 'First name',
        lastName: 'Last name',
        assigned: 'Assigned',
        assignedTo: 'Assigned to',
        truentityId: 'Truentity ID',
        createdOn: 'Created On',
        actions: 'Actions',
        name: 'Name'
      },
      assignToDialogTitle: 'Assign to',
      filters: {
        all: 'All',
        assigned: 'Assigned',
        unassigned: 'Unassigned'
      },
      actionsMenu: {
        label: 'Actions',
        groupLabel: 'Pharmacists Assignments',
        assign: 'Assign',
        unassign: 'Unassign'
      }
    },
    tasks: {
      title: 'Task List',
      pendingTab: 'Pending',
      completedTab: 'Completed',
      updateSuccessMessage: 'Successfully updated the Validation Status.',
      updateErrorMessage: 'Something went wrong.',
      columns: {
        type: 'Type',
        subType: 'Sub Type',
        billedAmount: 'Billed Amount',
        modeOfResolution: 'Mode Of Resolution',
        status: 'Status',
        healthPlan: 'Health Plan',
        performedOn: 'Performed On',
        performedBy: 'Performed By',
        numEncounters: '# of Encounters '
      },
      actionsMenu: {
        label: 'Actions',
        groupLabel: 'Validation Status',
        inProgress: 'In Progress',
        paymentPending: 'Payment Pending'
      }
    }
  },
  patientOnboarding: {
    title: 'Patient Onboarding',
    onboardPatients: 'Onboard Patients',
    allscripts: 'Allscripts',
    adtMonitoring: 'Adt Monitoring',
    onboardAllScriptsTitle: 'Onboard AllScripts Patients',
    onboardAdtTitle: 'Onboard Adt Patients'
  },
  healthPlans: {
    addDialogTitle: 'Add Health Plan',
    editDialogTitle: 'Edit Health Plan',
    addButtonLabel: 'Add Health Plan',
    columns: {
      healthPlans: 'Health Plans',
      edit: 'Edit'
    },
    form: {
      name: 'Name',
      addErrorMessage: 'Unable to add Health Plan',
      updateErrorMessage: 'Unable to update health plan'
    }
  },
  resources: {
    title: 'Resources',
    noResourcesMessage: 'No resources are available',
    openModeLabel: 'Open resource in',
    openModes: {
      currentWindow: 'Current window',
      newTab: 'New tab',
      newWindow: 'New window'
    },
    optionalSuffix: '(optional)',
    completedLabel: (completed: number, total: number) => `${completed} / ${total} Completed`,
    columns: {
      name: 'Name',
      description: 'Description',
      actions: 'Actions'
    },
    addResourceTitle: 'Add new Resource',
    editResourceTitle: 'Edit Resource',
    showArchivedLabel: 'Show archived',
    deleteDialogTitle: 'Delete resource',
    deleteDialogMessage: (name: string) => `Are you sure you want to delete <b>${name}</b>? This cannot be undone.`,
    deletedMessage: 'Resource deleted successfully',
    deleteErrorMessage: 'Unable to delete the resource.',
    reorderErrorMessage: 'Unable to reorder the resources.',
    manageLibraryLabel: 'Manage library',
    manageCategoriesButton: 'Manage categories',
    library: 'Library',
    allTypes: 'All types',
    searchTitle: 'Search resources',
    searchLabel: 'Search resources',
    searchAiTag: 'AI',
    searchHint: 'AI search reads inside every document, not just the titles. Ask a question or describe the situation.',
    searchPlaceholder: 'Ask a question, or try: blood pressure, gateway, insurance…',
    clearSearch: 'Clear search',
    resultCount: (count: number) => `${count} result${count === 1 ? '' : 's'}`,
    aiOverviewTitle: 'AI overview',
    aiOverviewCount: (count: number) => `${count} resource${count === 1 ? '' : 's'}`,
    aiOverviewMention: (query: string) => ` mention \u201C${query}\u201D, including inside the documents. Start with `,
    aiOverviewFooter: 'AI summary of matching resources. Confirm against the source.',
    noSearchResults: 'No resources match that search. Try a shorter word, or clear the search to browse.',
    foundInDocument: (page: number | null) => (page ? `Found in document · p. ${page}` : 'Found in document'),
    talentLmsMessage: 'Your training modules are located in the TalentLMS system. To revisit that material, ',
    talentLmsLink: 'click here to open TalentLMS',
    readerEmpty: 'Search above, or pick something on the left, to read it here.',
    archived: 'ARCHIVED',
    recentlyUpdated: 'Updated',
    download: 'Download',
    downloadResource: 'Download this resource',
    downloadUnavailable: 'Download is turned off for this resource',
    previewUnavailable: "Preview isn't available for this file type.",
    openInDialog: 'Open larger view',
    openInNewTab: 'Open in new tab',
    openInNewWindow: 'Open in new window',
    openExternallyMessage: 'This resource opens outside the portal.',
    edit: 'Edit',
    delete: 'Delete',
    dragToReorder: 'Drag to reorder',
    resourceTypes: {
      GUIDE: 'Guide',
      SOP: 'SOP',
      CHECKLIST: 'Checklist',
      SCRIPT: 'Script',
      JOB_AID: 'Job aid',
      HANDOUT: 'Handout',
      TEMPLATE: 'Template',
      VIDEO: 'Video',
      TRAINING: 'Training',
      OTHER: 'Other'
    },
    form: {
      name: 'Name',
      category: 'Category',
      newCategory: 'New category',
      resourceType: 'Type',
      useThisWhen: 'Use this when',
      useThisWhenHelper: 'One short line, e.g. "Respond to a critical alert safely."',
      searchKeywords: 'Search keywords',
      searchKeywordsHelper: 'Press Enter after each keyword.',
      allowDownload: 'Allow download',
      archived: 'Archived',
      currentResource: 'Current resource',
      replaceFile: 'Replace file',
      keepCurrentFile: 'Keep current file',
      attachFile: 'Attach a resource file',
      attachReplacementFile: 'Attach a file to replace the current resource',
      cancel: 'Cancel',
      addResource: 'Add Resource',
      saveChanges: 'Save Changes',
      savedMessage: 'Resource saved successfully',
      saveErrorMessage: 'Unable to save the resource.',
      fileRequired: 'Please attach a resource file',
      unsupportedFile: 'Unsupported file type'
    },
    categories: {
      dialogTitle: 'Manage categories',
      addCategory: 'Add category',
      addCategoryTitle: 'Add category',
      editCategoryTitle: 'Edit category',
      name: 'Name',
      icon: 'Icon',
      color: 'Colour',
      archived: 'Archived',
      resourceCount: (count: number) => `${count} resource${count === 1 ? '' : 's'}`,
      deleteNotEmpty: 'Move or delete its resources before deleting this category',
      deleteDialogTitle: 'Delete category',
      deleteDialogMessage: (name: string) => `Are you sure you want to delete <b>${name}</b>?`,
      savedMessage: 'Category saved successfully',
      deletedMessage: 'Category deleted successfully',
      saveErrorMessage: 'Unable to save the category.',
      deleteErrorMessage: 'Unable to delete the category.',
      reorderErrorMessage: 'Unable to reorder the categories.',
      empty: 'No categories yet.',
      close: 'Close',
      save: 'Save'
    }
  },
  logs: {
    title: 'Logs',
    logTypeNameLabel: 'Log Type Name',
    logTypesLabel: 'Log Types',
    selectPlaceholder: 'Select an option...',
    columns: {
      firstName: 'First Name',
      lastName: 'Last Name',
      logText: 'Log Text',
      logRecordedOn: 'Log recorded on'
    }
  },
  announcements: {
    title: 'Announcements',
    addButtonLabel: 'Add Announcements',
    myAnnouncementsTab: 'My Announcements',
    allAnnouncementsTab: 'All Announcements',
    addDialogTitle: 'Add Announcement',
    updateDialogTitle: 'Update Announcement',
    columns: {
      title: 'Title',
      type: 'Type',
      startAt: 'Start At',
      endAt: 'End At',
      alwaysVisible: 'Always visible',
      alwaysVisibleDescription: 'Always visible at time period',
      isActive: 'Is Active',
      readStatus: 'Read Status',
      actions: 'Actions'
    },
    deleteDialogTitle: 'Delete Announcement',
    deleteConfirmMessage: 'Are you sure you want to delete this announcement?',
    deleteErrorMessage: 'Unable to delete the announcement. Please try again later.',
    addErrorMessage: 'Unable to add the announcement. Please try again later.',
    updateErrorMessage: 'Unable to update the announcement. Please try again later.',
    wizard: {
      generalDetailsStep: 'General Details',
      composeAnnouncementStep: 'Compose Announcement',
      addMediaStep: 'Add Media (optional)',
      chooseRecipientsStep: 'Choose Recipients',
      updateButton: 'Update',
      saveButton: 'Save'
    },
    generalDetails: {
      title: 'General Details',
      titleLabel: 'Title',
      startTimeLabel: 'Start Time',
      endTimeLabel: 'End Time',
      typeLabel: 'Type',
      typePlaceholder: 'Select a type',
      alwaysVisibleLabel: 'Always visible during time period',
      enableAnnouncementLabel: 'Enable Announcement'
    },
    compose: {
      title: 'Compose Announcement',
      contentLabel: 'Content'
    },
    media: {
      title: 'Add Media (optional)',
      dropzoneLabel: 'Drag your photos or videos here, or'
    },
    recipients: {
      title: 'Select Recipients',
      columns: {
        name: 'Name',
        createdOn: 'Created On'
      }
    }
  },
  rxEventMetrics: {
    incomingEventsTab: 'Incoming Rx Events',
    jobSchedulesTab: 'Rx Event Job Schedules',
    todayLabelPrefix: 'Today',
    noDataForDate: 'No data available for this date',
    relyingPartiesCount: (count: number) => `${count} Relying ${count === 1 ? 'Party' : 'Parties'}`,
    totalEvents: 'Total events:',
    totalDuplicates: 'Total duplicates:',
    relyingParty: 'Relying Party',
    total: 'Total',
    stored: 'Stored',
    dropped: 'Dropped',
    dupDropped: 'Dup. Dropped',
    unique: 'Unique',
    duplicates: 'Duplicates',
    storedBreakdown: 'Stored Breakdown',
    droppedBreakdown: 'Dropped Breakdown',
    duplicateDroppedBreakdown: 'Duplicate Dropped Breakdown',
    uniqueBreakdown: 'Unique Breakdown',
    duplicatesBreakdown: 'Duplicates Breakdown',
    processedEvents: 'Processed Events',
    droppedInProcess: 'Dropped In Process',
    droppedInProcessTooltip: 'Events that did not make it through processing (incoming total minus processed all)',
    allInProcess: 'All In Process',
    allInProcessTooltip: 'Total processed events',
    enrolled: 'Enrolled',
    enrolledTooltip: 'Events from enrolled patients',
    unenrolled: 'Unenrolled',
    unenrolledTooltip: 'Events from unenrolled patients',
    notEnrolled: 'Not Enrolled',
    notEnrolledTooltip: 'Events from patients not yet enrolled',
    noBreakdownAvailable: 'No breakdown available',
    viewBreakdownTooltip: (title: string) => `View ${title.toLowerCase()}`,
    jobExecutionRetentionNotice:
      'Job execution data is retained for 7 days from today. Historical data beyond this period is not available.',
    selectDateLabel: 'Select Date',
    jobExecutionStatisticsTitle: 'Job Execution Statistics',
    loadingJobStats: 'Loading job execution stats...',
    noJobFoundForDate: (date: string) => `No job found for the rx events for the selected date: ${date}`,
    selectDatePrompt: 'Select a date to view job execution statistics'
  },
  timesheets: {
    statusLabel: 'Status',
    payPeriodsLabel: 'Pay Periods',
    userLabel: 'User',
    changeStatusLabel: 'Change Status',
    selectPlaceholder: 'Select an option...',
    selectPayPeriodPlaceholder: 'Select a pay period',
    allPayPeriodsLabel: 'All',
    submitTimesheetsButton: 'Submit Timesheets',
    approveOptionLabel: 'APPROVE',
    denyOptionLabel: 'DENY',
    addTimesheetButton: 'Add Timesheet',
    editTimesheetDialogTitle: 'Edit Timesheet',
    addTimesheetDialogTitle: 'Add Timesheet',
    addInvoiceButton: 'Add Invoice',
    addInvoiceDialogTitle: 'Add Invoice',
    deleteDialogTitle: 'Delete Timesheet',
    deleteConfirmMessage: 'Are you sure you want to delete this timesheet?',
    submitDialogTitle: 'Submit Timesheet',
    submitConfirmMessage: 'This timesheet will be submitted for Review by your Manager. Continue?',
    approveTimesheetsDialogTitle: 'Approve Timesheets?',
    denyTimesheetsDialogTitle: 'Deny Timesheets?',
    proceedConfirmMessage: 'Are you sure you want to proceed?',
    updateSuccessMessage: 'Timesheet updated',
    updateErrorMessage: 'Unable to update timesheet',
    deleteSuccessMessage: 'Timesheet deleted',
    deleteErrorMessage: 'Unable to delete timesheet',
    columns: {
      date: 'Date',
      time: 'Time',
      customer: 'Customer',
      task: 'Task',
      user: 'User',
      status: 'Status',
      actions: 'Actions'
    },
    addDialog: {
      datePerformedLabel: 'Date Performed',
      hoursLabel: 'Hours',
      minutesLabel: 'Minutes',
      descriptionLabel: 'Description',
      billedToOrgLabel: 'Task billed to Organization/Location',
      organizationLabel: 'Organization',
      storeLabel: 'Store',
      selectPlaceholder: 'Select an option...',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      saveSuccessMessage: 'Timesheet Saved',
      saveErrorMessage: 'Unable to save Timesheet'
    },
    invoiceDialog: {
      dateInvoicedLabel: 'Date Invoiced',
      descriptionLabel: 'Description',
      timeLabel: 'Time: ',
      hoursSuffix: 'Hours, ',
      minutesSuffix: 'Minutes',
      hourlyRateLabel: 'Hourly Rate: $',
      hourlyRateNotSetMessage: '(Hourly rate not set! Please Contact your Supervisor)',
      invoiceTotalLabel: 'Invoice Total: $',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      saveSuccessMessage: 'Invoice Saved',
      noHourlyRateErrorMessage: 'Unable to save Invoice. No hourly rate set',
      saveErrorMessage: 'Unable to save Invoice'
    }
  },
  invoices: {
    statusLabel: 'Status',
    userLabel: 'User',
    changeStatusLabel: 'Change Status',
    selectPlaceholder: 'Select an option...',
    payInvoicesDialogTitle: 'Pay Invoices?',
    payInvoicesConfirmMessage: 'Mark the selected invoices as Paid?',
    updateSuccessMessage: 'The selected invoice(s) have been updated',
    updateErrorMessage: 'Unable to update the selected invoice(s)',
    columns: {
      date: 'Date',
      totalTime: 'Total Time',
      value: 'Value',
      description: 'Description',
      user: 'User',
      status: 'Status',
      actions: 'Actions'
    },
    details: {
      backButton: 'Back',
      deleteButton: 'Delete',
      submitAndEmailButton: 'Submit and Email Invoice',
      emailToFinanceButton: 'Email Invoice to Finance',
      deleteDialogTitle: 'Delete Invoice',
      deleteConfirmMessage: 'This invoice has not been submitted yet and will be removed. Continue?',
      emailInvoiceDialogTitle: 'Email Invoice',
      emailInvoiceSuccessMessage: 'Invoice has been emailed to the recipients',
      inFinanceDialogTitle: 'Update Invoice status to In Finance and Email',
      inFinanceSuccessMessage: 'Invoice has been emailed to the recipient and status updated successfully',
      timesheetsTab: 'Timesheets',
      documentTab: 'Document',
      columns: {
        date: 'Date',
        time: 'Time',
        customer: 'Customer',
        task: 'Task',
        status: 'Status'
      }
    },
    emailDialog: {
      subjectLabel: 'Subject',
      emailLabel: 'Email',
      noSupervisorEmailMessage: 'Invoice can not be submitted. Please contact your supervisor to set up this email',
      sendErrorMessage: 'Error sending email. Please contact Tech Support',
      submitButton: 'Submit',
      cancelButton: 'Cancel'
    }
  }
} as const;
